import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Rings = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.449 10.562a5.8 5.8 0 1 0 4.414 4.413m.688 6.916a5.8 5.8 0 1 0-4.414-4.413M14.21 1.97a2.04 2.04 0 0 0-1.885 1.267 2.04 2.04 0 0 0-1.89-1.267A2.23 2.23 0 0 0 8.4 4.221c0 2.467 3.4 4.472 3.928 4.472s3.927-2 3.927-4.472A2.23 2.23 0 0 0 14.21 1.97"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Rings) as SvgIcon;
export { ForwardRef as ReactComponent };
